


  import dep0 from "ember-cli-babel/-embroider-implicit-modules.js";
  import dep1 from "ember-compatibility-helpers/-embroider-implicit-modules.js";
  import dep2 from "ember-cli-htmlbars/-embroider-implicit-modules.js";
  import dep3 from "ember-raf-scheduler/-embroider-implicit-modules.js";
  import dep4 from "@html-next/vertical-collection/-embroider-implicit-modules.js";
  import dep5 from "ember-classy-page-object/-embroider-implicit-modules.js";
  import dep6 from "ember-test-selectors/-embroider-implicit-modules.js";
  import dep7 from "ember-cli-node-assets/-embroider-implicit-modules.js";


export default Object.assign({},
    dep0,
    dep1,
    dep2,
    dep3,
    dep4,
    dep5,
    dep6,
    dep7,
  {
  }
);
